export default "__VITE_ASSET__Cetoj9vR__"